<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      
      <b-row>
        <b-col class="d-flex justify-content-between" cols="12">
          <h3> {{ mainTitle }} </h3>
          
          <feather-icon
            size="20"
            class="cursor-pointer"
            @click="modalOpen = false"
            icon="XIcon"
          />
        </b-col>
      </b-row>
      <hr />
      
      <b-skeleton v-if="working" width="100%" height="900px"></b-skeleton>
      <div v-else>

        <b-row >
          <b-col cols="12">
            <info-card
                label="نوع التبرع"
                :value="getLableType(nationalDonation.type)"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="مكان ورود التبرع"
              :value="nationalDonation.place_type === 'freezone' ? 'منطقة حرة':'دولة'"
            />
          </b-col>
          <b-col cols="12" v-if="nationalDonation.place_type === 'country'">
            <info-card label="الدولة"
              :value="nationalDonation.country_id ? nationalDonation.country_id.name : ''"
            />
          </b-col>
          <b-col cols="12" v-if="nationalDonation.place_type === 'freezone'">
            <info-card label="اسم المنطقة الحرة"
              :value="nationalDonation.free_zone_name"
            />
          </b-col>
          <b-col cols="12"  v-if="nationalDonation.place_type === 'country' && nationalDonation.type !== 'bank_donations'">
            <info-card label="المعبر الحدودي"
              :value="nationalDonation.border_crossing_id ? nationalDonation.border_crossing_id.name : ''"
            />
          </b-col>
  
          
        </b-row>
        <b-row v-if="nationalDonation.type === 'bank_donations' && nationalDonation.bankDonations">
          <b-col cols="12">
            <info-card label="رقم الحساب البنكي"
              :value="nationalDonation.bankDonations.bankAccount ? nationalDonation.bankDonations.bankAccount.account_no :''"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="مبلغ التبرع"
              :value="nationalDonation.bankDonations.donated_amount"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="العملة المُتبرع بها"
              :value="nationalDonation.bankDonations.currencyType ? nationalDonation.bankDonations.currencyType.name_ar :''"
            />
          </b-col>
        </b-row>
        <b-row  v-if="nationalDonation.type === 'in_kind_donations' && nationalDonation.inKindDonations">
          <b-col cols="12">
            <info-card label="الوصف"
              :value="nationalDonation.inKindDonations.description"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="كمية التبرع"
              :value="nationalDonation.inKindDonations.donated_amount"
            />
          </b-col>
        </b-row>
        <b-row  v-if="nationalDonation.type === 'machines' && nationalDonation.machines">
          <b-col cols="12">
            <info-card label="نوع المركبة"
              :value="nationalDonation.machines.machineType ? nationalDonation.machines.machineType.name_ar : ''"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="الطراز"
              :value="nationalDonation.machines.model"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="رقم اللوحة"
              :value="nationalDonation.machines.plate_number"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="المحافظة"
              :value="nationalDonation.machines.governorate ? nationalDonation.machines.governorate.name : ''"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="الرقم التسلسلي"
              :value="nationalDonation.machines.serial_number"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="رقم الهيكل"
              :value="nationalDonation.machines.structure_no"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="سنة الصنع"
              :value="nationalDonation.machines.year"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="نوع الوقود"
              :value="nationalDonation.machines.fuel_type_id ? nationalDonation.machines.fuel_type_id.name_ar : ''"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="عدد الركاب"
              :value="nationalDonation.machines.passengers_number"
            />
          </b-col>
          <b-col cols="12">
            <info-card label="صيغة التملك"
              :value="nationalDonation.machines.possessiveForm ? nationalDonation.machines.possessiveForm.name_ar : ''"
            />
          </b-col>
  
          
          <b-col cols="12">
            <info-card label="معفاة من الضرائب"
              :value="nationalDonation.tax === 1 ? 'نعم' : 'لا'"
            />
          </b-col>
          
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-2">
            <h5>
              المُرفقات :
            </h5>
          </b-col>
          <b-col cols="12">
            
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  صورة عن الهوية أو جواز سفر المتبرع
                </div>
                <div>
                  <b-button
  
                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:nationalDonation.identification_file } }"
                  >
                    <feather-icon icon="EyeIcon"
                    /></b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
          <b-col cols="12"   v-if="nationalDonation.type === 'machines' && nationalDonation.machines">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  وثيقة الملكية
                </div>
                <div>
                  <b-button
  
                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:nationalDonation.machines.ownership_doc } }"
                  >
                    <feather-icon icon="EyeIcon"/>
                  </b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
          
          <b-col cols="12" v-if="nationalDonation.type === 'in_kind_donations' && nationalDonation.inKindDonations">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  الفاتورة
                </div>
                <div>
                  <b-button
  
                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:nationalDonation.inKindDonations.identification_file } }"
                  >
                    <feather-icon icon="EyeIcon"
                    /></b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
  
          <b-col cols="12" v-if="nationalDonation.type === 'in_kind_donations' && nationalDonation.inKindDonations">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  بوليصة الشحن الموازنة
                </div>
                <div>
                  <b-button
  
                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:nationalDonation.inKindDonations.bill_of_lading_file } }"
                  >
                    <feather-icon icon="EyeIcon"
                    /></b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
  
          <b-col cols="12" v-if="nationalDonation.type === 'in_kind_donations' && nationalDonation.inKindDonations">
            <div class="info-card px-2 py-1 my-1">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                 بيانات التبرع
                </div>
                <div>
                  <b-button
  
                      variant="flat-info"
                      v-b-toggle.doc-view
                      class="btn-icon mx-25"
                      v-b-tooltip.hover.v-info.bottom
                      title="عرض المستند المرفوع"
                      :to="{ name: 'file-view', query: { ep:nationalDonation.inKindDonations.insurance_file } }"
                  >
                    <feather-icon icon="EyeIcon"/>
                  </b-button>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton , BSidebar , BSkeleton } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
const initForm = { id : null};
export default {
  data() {
    return {
      form: {},
    }
  },
  components: {
    BCard, BImg , BCol , InfoCard , BRow , BButton , BSidebar , BSkeleton
  },
  computed:{
    ...mapGetters("Financial", [
      "nationalDonation", "working"
    ]),
    
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  props: {
    value: Boolean,
    data : Object ,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات التبرع",
    },
    id: {
      type: Number,
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  watch: {
    async modalOpen(newVal) {
      if(newVal){

        console.log("id" , this.form)
         await this.fetchNationalDonations(this.form.id).then(()=> {
        });
      }
    },
  },
  methods:{
    ...mapActions("Financial", [
      "fetchNationalDonations",
    ]),
    getLableType(type){
      switch (type){
        case 'bank_donations':
          return 'تبرع مالي'
        case 'in_kind_donations':
          return 'تبرع عيني'
        case 'machines':
          return 'تبرع مركبة'
        default:
          return ''
      }
    },
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    getLableType(type){
      switch (type){
        case 'bank_donations':
          return 'تبرع مالي'
        case 'in_kind_donations':
          return 'تبرع عيني'
        case 'machines':
          return 'تبرع مركبة'
        default:
          return ''
      }
    },
  },

  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
};
</script>